export const aboutInfo = {
  brandName: '国产自拍视频精选合集',
  intro:
    '国产自拍视频精选合集诞生于2024年，由一群热爱本土原创视频内容的创作者和编辑共同发起。我们坚信，最打动人心的故事往往来自最真实的生活。在这个平台上，每一位创作者都用镜头记录着自己的世界——无论是街角的早餐摊、清晨的第一缕阳光，还是旅途中偶遇的陌生人、厨房里飘出的饭菜香，这些最平凡也最珍贵的瞬间构成了我们眼中的"中国故事"。',
  mission:
    '我们致力于打造中国最具影响力的本土原创自拍视频内容平台，让每一个有故事的人都能被看见、被听见。通过精选推荐和内容引导，我们帮助观众发现更多优质的本土视频内容，同时也为创作者提供展示才华、分享生活的舞台。',
  values: [
    {
      title: '真实为本',
      desc: '拒绝过度包装，只推真实的原创内容。每一部作品都是创作者真实生活的记录，没有剧本，没有表演，只有最自然的生活流。',
      icon: 'ri-shield-check-line',
    },
    {
      title: '品质至上',
      desc: '严格的内容筛选机制，从画面质量到创意表达，从内容价值到情感传递，我们用心挑选每一部推荐作品。',
      icon: 'ri-star-line',
    },
    {
      title: '多元包容',
      desc: '八大内容分类覆盖生活的方方面面，无论你关注什么领域，都能在这里找到属于自己的那片天地。',
      icon: 'ri-global-line',
    },
    {
      title: '创作者优先',
      desc: '尊重每一位创作者的劳动成果，为优质原创内容提供更多曝光机会，助力本土创作者成长。',
      icon: 'ri-heart-line',
    },
  ],
  testimonials: [
    {
      name: '小鹿生活记',
      role: '生活记录创作者',
      content:
        '自从作品被收录到国产自拍视频精选合集后，我的视频播放量增长了近三倍，收到了很多温暖的评论和鼓励。这个平台真的帮助了很多像我一样的普通创作者被更多人看到。',
      avatar: 'https://readdy.ai/api/search-image?query=Cute%20young%20Chinese%20woman%20portrait%2C%20warm%20smile%2C%20simple%20cream%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%2C%20casual%20style%2C%20friendly%20expression%2C%20square%20format&width=120&height=120&seq=testimonial-01&orientation=squarish',
    },
    {
      name: '行走的阿明',
      role: '旅行Vlog创作者',
      content:
        '作为一个独立旅行博主，国产自拍视频精选合集给了我一个很好的展示平台。编辑的推荐非常专业，观众群体也很精准，每次新视频上线都能收到很多有意义的讨论。',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20outdoor%20travel%20style%2C%20friendly%20smile%2C%20simple%20cream%20background%2C%20professional%20headshot%2C%20adventurous%20vibe%2C%20square%20format&width=120&height=120&seq=testimonial-02&orientation=squarish',
    },
    {
      name: '饭饭而谈',
      role: '美食探店创作者',
      content:
        '做美食探店快三年了，国产自拍视频精选合集是我见过的对创作者最友好的平台。不仅推荐机制透明，还会给创作者很多有用的建议和反馈，真正做到了与创作者共同成长。',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20food%20blogger%20woman%20portrait%2C%20warm%20smile%2C%20simple%20cream%20background%2C%20professional%20headshot%2C%20friendly%20and%20energetic%20expression%2C%20square%20format&width=120&height=120&seq=testimonial-03&orientation=squarish',
    },
    {
      name: '视觉玩家阿杰',
      role: '创意短片创作者',
      content:
        '这个平台对于创意类内容的支持力度让我非常感动。他们不只是看流量数据，更看重作品的创意和品质。在这里我找到了很多志同道合的创作伙伴，也学到了很多新的拍摄技巧。',
      avatar: 'https://readdy.ai/api/search-image?query=Creative%20young%20Chinese%20man%20portrait%2C%20artistic%20style%2C%20simple%20cream%20background%2C%20professional%20headshot%2C%20cinematographer%20vibe%2C%20square%20format&width=120&height=120&seq=testimonial-04&orientation=squarish',
    },
  ],
  contact: {
    email: 'contact@zpaivideo.cn',
    wechat: 'zpaivideo_official',
    address: '上海市浦东新区张江高科技园区',
    phone: '021-6888-8888',
  },
};